import { useQuery } from "@tanstack/react-query";
import { fetch } from "./fetch";
import { Booking } from "../app/Bookings/model";

const getBookingByYachtOfferData = async (bookingId: string) => {
  return fetch<Booking>(`/api/bookings/offer-yacht/${bookingId}`);
};

export const useBookingCharterDataQuery = (bookingId: string) => {
  return useQuery({
    queryKey: ["bookingYachtOfferData", bookingId],
    queryFn: () => getBookingByYachtOfferData(bookingId),
    enabled: !!bookingId,
  });
};
